import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";

// Configuration d'édition. Tant que l'association n'est pas officiellement déclarée,
// laisser `declared` à false : la version publique n'affiche ni siège ni RNA.
// Après déclaration, renseigner siege + rna réels et passer declared à true.
const ASSOCIATION = {
  declared: false,
  siege: "",
  rna: "",
};
const showAssociation = ASSOCIATION.declared && ASSOCIATION.siege && ASSOCIATION.rna;

const Block = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display font-black text-2xl md:text-3xl uppercase text-ink leading-none">{title}</h2>
    <div className="mt-4 prose-editorial text-lg">{children}</div>
  </section>
);

export default function MentionsLegales() {
  useSEO({
    title: "Mentions légales",
    description: "Mentions légales de Contre-épreuve : édition, hébergement, propriété intellectuelle, responsabilité et données personnelles.",
  });
  return (
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-14 md:py-20">
      <header>
        <p className="text-orange font-bold text-sm uppercase tracking-wide mb-4">Mentions légales</p>
        <h1 className="font-display font-black text-5xl md:text-6xl uppercase leading-[0.92] text-ink">
          Mentions légales
        </h1>
      </header>

      <Block title="Édition">
        {showAssociation ? (
          <p>
            Le site Contre-épreuve est édité par l'association Contre-épreuve, association régie par la
            loi du 1er juillet 1901.<br />
            Siège social : {ASSOCIATION.siege}<br />
            Numéro RNA : {ASSOCIATION.rna}<br />
            Directeur de la publication : Simon Marie<br />
            Contact : <a href="mailto:contact@contre-epreuve.fr">contact@contre-epreuve.fr</a>
          </p>
        ) : (
          <p>
            Éditeur et directeur de la publication : Simon Marie<br />
            Contact : <a href="mailto:contact@contre-epreuve.fr">contact@contre-epreuve.fr</a>
          </p>
        )}
      </Block>

      <Block title="Hébergement">
        <p>
          Le site est hébergé par Netlify, Inc., 101 2nd Street, San Francisco, CA 94105, États-Unis.
        </p>
      </Block>

      <Block title="Propriété intellectuelle">
        <p>
          Sauf indication contraire, les textes et éléments éditoriaux publiés sur Contre-épreuve sont
          protégés par le droit de la propriété intellectuelle.
        </p>
        <p>
          Ils peuvent faire l'objet de courtes citations, sous réserve de mentionner leur auteur, le
          titre du contenu et son adresse d'origine. Toute reproduction intégrale ou substantielle
          nécessite une autorisation préalable.
        </p>
      </Block>

      <Block title="Responsabilité">
        <p>
          Contre-épreuve veille à la précision des informations publiées. Une erreur ou une demande
          concernant un contenu peut être signalée à la rédaction depuis la page{" "}
          <Link to="/contact">Contact</Link>.
        </p>
        <p>
          Lorsque les éléments transmis le justifient, le contenu concerné peut être corrigé ou
          complété.
        </p>
      </Block>

      <Block title="Données personnelles">
        <p>
          Les informations transmises au moyen des formulaires sont utilisées pour traiter les
          demandes adressées à Contre-épreuve.
        </p>
        <p>
          Les modalités de traitement, de conservation et d'exercice des droits sont présentées dans la{" "}
          <Link to="/confidentialite">politique de confidentialité</Link>.
        </p>
      </Block>
    </div>
  );
}
